__turbopack_context__.v({
  "footer_content_links": "StagingFooter-module__KP_bIq__footer_content_links",
  "footer_link": "StagingFooter-module__KP_bIq__footer_link",
  "footer_logo_and_links": "StagingFooter-module__KP_bIq__footer_logo_and_links",
  "footer_shell": "StagingFooter-module__KP_bIq__footer_shell",
  "footer_sub_text": "StagingFooter-module__KP_bIq__footer_sub_text",
  "footer_wrapper": "StagingFooter-module__KP_bIq__footer_wrapper",
});
